import { render } from "./newFilePanel.vue?vue&type=template&id=342d5b4a"
import script from "./newFilePanel.vue?vue&type=script&lang=js"
export * from "./newFilePanel.vue?vue&type=script&lang=js"

import exportComponent from "/www/wwwroot/www.usevia.cn/fileManage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__